module.exports = __webpack_public_path__ + "static/media/halloween5.27a4287c.webp";